// import React, { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { useAuth } from "../../contexts/AuthContext";
// import toast from "react-hot-toast";
// import { GoogleLogin } from "@react-oauth/google";

// const Login: React.FC = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [showForgotPassword, setShowForgotPassword] = useState(false);
//   const [otpEmail, setOtpEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [resetToken, setResetToken] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpVerified, setOtpVerified] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   const navigate = useNavigate();
//   const { login, sendOtp, verifyOtp, resetPassword, googleLogin } = useAuth();

//   const handleLogin = async (e: React.FormEvent) => {
//     e.preventDefault();

//     if (!email.trim()) {
//       toast.error("กรุณากรอกอีเมล");
//       return;
//     }

//     if (!password.trim()) {
//       toast.error("กรุณากรอกรหัสผ่าน");
//       return;
//     }

//     setIsLoading(true);

//     try {
//       // Get anonymous chats from localStorage before login
//       const anonymousStorage = localStorage.getItem("anonymous_chats");
//       let anonymousChatIds: string[] = [];

//       if (anonymousStorage) {
//         try {
//           const parsedData = JSON.parse(anonymousStorage);

//           // Extract chat IDs from the structure
//           if (parsedData.chats && Array.isArray(parsedData.chats)) {
//             anonymousChatIds = parsedData.chats
//               .map((chat: any) => chat.id)
//               .filter((id: string) => id && !id.startsWith("temp-")); // Exclude temp IDs

//             console.log("Found anonymous chat IDs:", anonymousChatIds);
//           }
//         } catch (parseError) {
//           console.error("Failed to parse anonymous chats:", parseError);
//         }
//       }

//       // Call login without roleId parameter
//       await login(email, password, anonymousChatIds);

//       // Navigate after successful login
//       navigate("/");
//     } catch (error) {
//       // Error is already handled in AuthContext
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleAppleLogin = () => {
//     console.log("clicked here ->>>");
//     window.location.href = `https://chatboat.encdemo.com/api/auth/apple/start`;
//   };

//   const handleSendOtp = async () => {
//     if (!otpEmail.trim()) {
//       toast.error("Please enter your email");
//       return;
//     }

//     try {
//       await sendOtp(otpEmail);
//       setOtpSent(true);
//       toast.success("OTP sent to your email");
//     } catch (error: any) {
//       toast.error(error.response?.data?.error || "Failed to send OTP");
//     }
//   };

//   const handleVerifyOtp = async () => {
//     if (!otp.trim()) {
//       toast.error("Please enter OTP");
//       return;
//     }

//     try {
//       const result = await verifyOtp(otpEmail, otp);

//       if (result.status === "UNREGISTERED_USER") {
//         toast.error("Email not registered. Please sign up first.");
//         setShowForgotPassword(false);
//         return;
//       }

//       if (result.resetToken) {
//         setResetToken(result.resetToken);
//         setOtpVerified(true);
//         toast.success("OTP verified. Set new password.");
//       }
//     } catch (error: any) {
//       toast.error(error.response?.data?.error || "Invalid OTP");
//     }
//   };

//   const handleResetPassword = async () => {
//     if (!newPassword.trim()) {
//       toast.error("Please enter new password");
//       return;
//     }

//     if (newPassword.length < 6) {
//       toast.error("Password must be at least 6 characters");
//       return;
//     }

//     try {
//       await resetPassword(resetToken, newPassword);
//       toast.success("Password reset successful! Please login.");
//       setShowForgotPassword(false);
//       resetForgotPasswordState();
//     } catch (error: any) {
//       toast.error(error.response?.data?.error || "Password reset failed");
//     }
//   };

//   const resetForgotPasswordState = () => {
//     setOtpEmail("");
//     setOtp("");
//     setNewPassword("");
//     setResetToken("");
//     setOtpSent(false);
//     setOtpVerified(false);
//   };

//   // Forgot Password Modal
//   const ForgotPasswordModal = () => (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//       <div className="bg-gray-800 rounded-xl p-6 max-w-md w-full">
//         <h3 className="text-xl font-semibold text-white mb-4">
//           ตั้งรหัสผ่านใหม่
//         </h3>

//         {!otpSent ? (
//           <div>
//             <p className="text-gray-300 mb-4">
//               Enter your email to receive OTP
//             </p>
//             <input
//               type="email"
//               value={otpEmail}
//               onChange={(e) => setOtpEmail(e.target.value)}
//               className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white mb-4"
//               placeholder="กรอกอีเมลของคุณ"
//             />
//             <div className="flex gap-2">
//               <button
//                 onClick={handleSendOtp}
//                 className="flex-1 py-2 bg-primary text-white rounded-lg "
//               >
//                 ส่งรหัส OTP
//               </button>
//               <button
//                 onClick={() => {
//                   setShowForgotPassword(false);
//                   resetForgotPasswordState();
//                 }}
//                 className="flex-1 py-2 bg-gray-700 text-white rounded-lg"
//               >
//                 ยกเลิก
//               </button>
//             </div>
//           </div>
//         ) : !otpVerified ? (
//           <div>
//             <p className="text-gray-300 mb-4">
//               Enter the OTP sent to your email
//             </p>
//             <input
//               type="text"
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//               className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white mb-4"
//               placeholder="Enter 6-digit OTP"
//               maxLength={6}
//             />
//             <div className="flex gap-2">
//               <button
//                 onClick={handleVerifyOtp}
//                 className="flex-1 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark"
//               >
//                 ยืนยันรหัส OTP
//               </button>
//               <button
//                 onClick={() => {
//                   setOtpSent(false);
//                   setOtp("");
//                 }}
//                 className="flex-1 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-600"
//               >
//                 Back
//               </button>
//             </div>
//           </div>
//         ) : (
//           <div>
//             <p className="text-gray-300 mb-4">Set your new password</p>
//             <input
//               type="password"
//               value={newPassword}
//               onChange={(e) => setNewPassword(e.target.value)}
//               className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white mb-4"
//               placeholder="New password (min 6 characters)"
//             />
//             <div className="flex gap-2">
//               <button
//                 onClick={handleResetPassword}
//                 className="flex-1 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark"
//               >
//                 ตั้งรหัสผ่านใหม่
//               </button>
//               <button
//                 onClick={() => {
//                   setShowForgotPassword(false);
//                   resetForgotPasswordState();
//                 }}
//                 className="flex-1 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-600"
//               >
//                 ยกเลิก
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gray-300 flex flex-col justify-center py-6 sm:py-12 px-4 sm:px-6 lg:px-8">
//       {showForgotPassword && <ForgotPasswordModal />}

//       <div className="sm:mx-auto sm:w-full sm:max-w-md">
//         <div className="flex justify-center">
//           <div className="text-4xl mb-4">🤖</div>
//         </div>
//         <h2 className="mt-2 text-center text-2xl sm:text-3xl font-extrabold text-black">
//           Welcome back
//         </h2>
//         <p className="mt-2 text-center text-sm text-gray-300">
//           Or{" "}
//           <Link
//             to="/register"
//             className="font-medium text-base text-black underline transition-colors"
//           >
//             create a new account
//           </Link>
//         </p>
//       </div>

//       <div className="mt-6 sm:mt-8 sm:mx-auto sm:w-full sm:max-w-md">
//         <div className="bg-gray-800/50 backdrop-blur-sm py-6 sm:py-8 px-4 sm:px-10 shadow-2xl rounded-2xl border border-gray-700">
//           <form className="space-y-4 sm:space-y-6" onSubmit={handleLogin}>
//             <div>
//               <label
//                 htmlFor="email"
//                 className="block text-sm font-medium text-white"
//               >
//                 Email address *
//               </label>
//               <div className="mt-1">
//                 <input
//                   id="email"
//                   name="email"
//                   type="email"
//                   autoComplete="email"
//                   required
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   className="appearance-none block w-full px-3 py-3 bg-gray-700 border border-gray-600 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-white text-sm sm:text-base transition-all"
//                   placeholder="you@example.com"
//                 />
//               </div>
//             </div>

//             <div>
//               <div className="flex items-center justify-between">
//                 <label
//                   htmlFor="password"
//                   className="block text-sm font-medium text-white"
//                 >
//                   Password *
//                 </label>
//                 <button
//                   type="button"
//                   onClick={() => setShowForgotPassword(true)}
//                   className="text-sm text-white underline transition-colors"
//                 >
//                   ลืมรหัสผ่าน?
//                 </button>
//               </div>
//               <div className="mt-1">
//                 <input
//                   id="password"
//                   name="password"
//                   type="password"
//                   autoComplete="current-password"
//                   required
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   className="appearance-none block w-full px-3 py-3 bg-gray-700 border border-gray-600 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-white text-sm sm:text-base transition-all"
//                   placeholder="••••••••"
//                 />
//               </div>
//             </div>

//             <div>
//               <button
//                 type="submit"
//                 disabled={isLoading}
//                 className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm sm:text-base font-medium text-white bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 active:scale-95"
//               >
//                 {isLoading ? (
//                   <>
//                     <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
//                     Signing in...
//                   </>
//                 ) : (
//                   "Sign in"
//                 )}
//               </button>
//             </div>
//           </form>

//           {/* Demo credentials - Remove roleId from demo buttons as well */}
//           {/* <div className="mt-6 sm:mt-8">
//             <div className="relative">
//               <div className="absolute inset-0 flex items-center">
//                 <div className="w-full border-t border-gray-600" />
//               </div>
//               <div className="relative flex justify-center text-sm">
//                 <span className="px-2 bg-gray-800/50 text-gray-400">
//                   Try demo credentials
//                 </span>
//               </div>
//             </div>
//             <div className="mt-4 space-y-2">
//               <button
//                 onClick={() => {
//                   setEmail('admin@example.com');
//                   setPassword('password');
//                 }}
//                 className="w-full text-left p-3 bg-gray-700/50 hover:bg-gray-700 rounded-lg transition-colors group"
//               >
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <div className="font-medium text-white group-hover:text-primary transition-colors">
//                       Admin Account
//                     </div>
//                     <div className="text-sm text-gray-400">admin@example.com / password</div>
//                   </div>
//                   <div className="text-lg">👑</div>
//                 </div>
//               </button>
//               <button
//                 onClick={() => {
//                   setEmail('user@example.com');
//                   setPassword('password');
//                 }}
//                 className="w-full text-left p-3 bg-gray-700/50 hover:bg-gray-700 rounded-lg transition-colors group"
//               >
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <div className="font-medium text-white group-hover:text-primary transition-colors">
//                       Regular User
//                     </div>
//                     <div className="text-sm text-gray-400">user@example.com / password</div>
//                   </div>
//                   <div className="text-lg">👤</div>
//                 </div>
//               </button>
//             </div>
//           </div> */}

//           {/* Social login */}
//           <div className="mt-6">
//             <div className="relative">
//               <div className="relative flex justify-center text-sm">
//                 <span className="px-2 text-white text-sm">
//                   หรือดำเนินการต่อด้วย
//                 </span>
//               </div>
//             </div>
//             <div className="mt-4 grid grid-cols-2 gap-3">
//               <button
//                 type="button"
//                 onClick={handleAppleLogin}
//                 className="w-full inline-flex justify-center py-2.5 px-4 border border-gray-600 rounded-lg shadow-sm bg-black text-sm font-medium text-white transition-colors"
//               >
//                 <svg
//                   className="w-5 h-5 mr-2"
//                   fill="currentColor"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.666-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.787-.94 1.324-2.245 1.171-3.54-1.133.052-2.518.754-3.334 1.701-.735.85-1.389 2.207-1.208 3.514 1.26.091 2.544-.638 3.371-1.675z" />
//                 </svg>
//                 Apple
//               </button>

//               <div className="relative w-full">
//                 <button
//                   type="button"
//                   disabled={isLoading}
//                   className="w-full inline-flex items-center justify-center py-2.5 px-4 border border-gray-600 rounded-lg shadow-sm bg-black text-sm font-medium text-white transition-colors disabled:opacity-50"
//                 >
//                   <svg className="w-5 h-5 mr-2" viewBox="0 0 48 48">
//                     <path
//                       fill="#EA4335"
//                       d="M24 9.5c3.54 0 6.72 1.22 9.22 3.6l6.9-6.9C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l8.03 6.22C12.43 13.72 17.74 9.5 24 9.5z"
//                     />
//                     <path
//                       fill="#4285F4"
//                       d="M46.5 24c0-1.64-.15-3.22-.43-4.75H24v9h12.7c-.55 2.96-2.22 5.47-4.7 7.16l7.2 5.59C43.98 36.36 46.5 30.7 46.5 24z"
//                     />
//                     <path
//                       fill="#FBBC05"
//                       d="M10.59 28.44c-.48-1.45-.76-2.99-.76-4.44s.27-2.99.76-4.44l-8.03-6.22C.92 16.46 0 20.12 0 24s.92 7.54 2.56 10.66l8.03-6.22z"
//                     />
//                     <path
//                       fill="#34A853"
//                       d="M24 48c6.48 0 11.93-2.13 15.9-5.8l-7.2-5.59c-2 1.34-4.56 2.14-8.7 2.14-6.26 0-11.57-4.22-13.41-9.94l-8.03 6.22C6.51 42.62 14.62 48 24 48z"
//                     />
//                   </svg>
//                   Google
//                 </button>

//                 <div className="absolute inset-0 opacity-0">
//                   <GoogleLogin
//                     onSuccess={async (res) => {
//                       const idToken = res.credential;
//                       if (!idToken) {
//                         toast.error("ไม่พบโทเค็น Google");
//                         return;
//                       }
//                       await googleLogin(idToken);
//                       navigate("/");
//                     }}
//                     onError={() => toast.error("เข้าสู่ระบบด้วย Google ไม่สำเร็จ")}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         {/* <div className="mt-6 text-center text-sm text-black">
//           <p>By signing in, you agree to our</p>
//           <p>
//             <a href="#" className="text-black underline transition-colors">
//               Terms of Service
//             </a>{" "}
//             and{" "}
//             <a href="#" className="text-black underline transition-colors">
//               Privacy Policy
//             </a>
//           </p>
//         </div> */}
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import toast from "react-hot-toast";
import { GoogleLogin } from "@react-oauth/google";
import { getCachedTestDomain, refreshTestDomain } from "../../utils/testDomain";

const colors = {
  amethyst: "#6D4C92",
  darkAmethyst: "#2D1B44",
  roseGold: "#E5B8AD",
  pearl: "#F8F4FF",
};

type ForgotPasswordModalProps = {
  otpSent: boolean;
  otpVerified: boolean;
  otpEmail: string;
  otp: string;
  newPassword: string;
  onOtpEmailChange: (value: string) => void;
  onOtpChange: (value: string) => void;
  onNewPasswordChange: (value: string) => void;
  onSendOtp: () => void;
  onVerifyOtp: () => void;
  onResetPassword: () => void;
  onClose: () => void;
};

const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({
  otpSent,
  otpVerified,
  otpEmail,
  otp,
  newPassword,
  onOtpEmailChange,
  onOtpChange,
  onNewPasswordChange,
  onSendOtp,
  onVerifyOtp,
  onResetPassword,
  onClose,
}) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
    <div
      className="w-full max-w-md rounded-[2.5rem] p-8 shadow-2xl"
      style={{
        background: `linear-gradient(180deg, ${colors.amethyst}, ${colors.darkAmethyst})`,
      }}
    >
      <h3 className="text-2xl font-semibold text-center text-white mb-6 tracking-wide">
        🌙 รีเซ็ตรหัสผ่าน
      </h3>

      {!otpSent ? (
        <>
          <input
            autoFocus
            type="email"
            value={otpEmail}
            onChange={(e) => onOtpEmailChange(e.target.value)}
            placeholder="กรอกอีเมลของคุณ"
            className="w-full mb-4 rounded-xl p-3 text-sm outline-none"
          />
          <button
            type="button"
            onClick={onSendOtp}
            className="w-full rounded-xl py-3 font-medium text-[#2D1B44]"
            style={{ backgroundColor: colors.roseGold }}
          >
            ส่งรหัส OTP
          </button>
        </>
      ) : !otpVerified ? (
        <>
          <input
            autoFocus
            value={otp}
            onChange={(e) => onOtpChange(e.target.value)}
            placeholder="กรอกรหัส OTP"
            className="w-full mb-4 rounded-xl p-3 text-sm outline-none"
          />
          <button
            type="button"
            onClick={onVerifyOtp}
            className="w-full rounded-xl py-3 font-medium text-[#2D1B44]"
            style={{ backgroundColor: colors.roseGold }}
          >
            ยืนยันรหัส OTP
          </button>
        </>
      ) : (
        <>
          <input
            autoFocus
            type="password"
            value={newPassword}
            onChange={(e) => onNewPasswordChange(e.target.value)}
            placeholder="รหัสผ่านใหม่"
            className="w-full mb-4 rounded-xl p-3 text-sm outline-none"
          />
          <button
            type="button"
            onClick={onResetPassword}
            className="w-full rounded-xl py-3 font-medium text-[#2D1B44]"
            style={{ backgroundColor: colors.roseGold }}
          >
            ตั้งรหัสผ่านใหม่
          </button>
        </>
      )}

      <button
        type="button"
        onClick={onClose}
        className="mt-6 block mx-auto text-sm text-white/70 underline"
      >
        ยกเลิก
      </button>
    </div>
  </div>
);

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [otpEmail, setOtpEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [resetToken, setResetToken] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [testDomain, setTestDomain] = useState(getCachedTestDomain());

  useEffect(() => {
    refreshTestDomain().then(setTestDomain);
  }, []);

  const navigate = useNavigate();
  const { login, sendOtp, verifyOtp, resetPassword, googleLogin } = useAuth();

  /* ---------------- LOGIN ---------------- */
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("กรุณากรอกอีเมล");
      return;
    }

    if (!password.trim()) {
      toast.error("กรุณากรอกรหัสผ่าน");
      return;
    }

    setIsLoading(true);

    try {
      // Get anonymous chats from localStorage before login
      const anonymousStorage = localStorage.getItem("anonymous_chats");
      let anonymousChatIds: string[] = [];

      if (anonymousStorage) {
        try {
          const parsedData = JSON.parse(anonymousStorage);

          // Extract chat IDs from the structure
          if (parsedData.chats && Array.isArray(parsedData.chats)) {
            anonymousChatIds = parsedData.chats
              .map((chat: any) => chat.id)
              .filter((id: string) => id && !id.startsWith("temp-")); // Exclude temp IDs

            console.log("Found anonymous chat IDs:", anonymousChatIds);
          }
        } catch (parseError) {
          console.error("Failed to parse anonymous chats:", parseError);
        }
      }

      // Call login without roleId parameter
      await login(email, password, anonymousChatIds);

      // Navigate after successful login
      navigate("/");
    } catch (error) {
      // Error is already handled in AuthContext
    } finally {
      setIsLoading(false);
    }
  };

  const handleAppleLogin = () => {
    window.location.href = "https://chatboat.encdemo.com/api/auth/apple/start";
  };

  /* ---------------- OTP FLOW ---------------- */
  const handleSendOtp = async () => {
    if (!otpEmail) return toast.error("กรุณากรอกอีเมล");
    await sendOtp(otpEmail);
    setOtpSent(true);
  };

  const handleVerifyOtp = async () => {
    const result = await verifyOtp(otpEmail, otp);
    if (result.resetToken) {
      setResetToken(result.resetToken);
      setOtpVerified(true);
    }
  };

  const handleResetPassword = async () => {
    await resetPassword(resetToken, newPassword);
    toast.success("ตั้งรหัสผ่านใหม่สำเร็จ");
    setShowForgotPassword(false);
  };

  /* ---------------- UI ---------------- */
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden"
      style={{
        background: `radial-gradient(circle at top, ${colors.amethyst}, ${colors.darkAmethyst})`,
      }}
    >
      {/* Star texture */}
      <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" />

      {showForgotPassword && (
        <ForgotPasswordModal
          otpSent={otpSent}
          otpVerified={otpVerified}
          otpEmail={otpEmail}
          otp={otp}
          newPassword={newPassword}
          onOtpEmailChange={setOtpEmail}
          onOtpChange={setOtp}
          onNewPasswordChange={setNewPassword}
          onSendOtp={handleSendOtp}
          onVerifyOtp={handleVerifyOtp}
          onResetPassword={handleResetPassword}
          onClose={() => setShowForgotPassword(false)}
        />
      )}

      <div
        className="relative z-10 w-full max-w-md rounded-[2.8rem] p-8 shadow-2xl"
        style={{ backgroundColor: colors.pearl }}
      >
        <h2 className="text-3xl font-bold text-center text-[#2D1B44] mb-2">
          ยินดีต้อนรับกลับ ✨
        </h2>
        <p className="text-center text-sm text-gray-500 mb-6">
          เชื่อมต่อกับพลังจักรวาลของคุณ
        </p>

        <form onSubmit={handleLogin} className="space-y-4">
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="อีเมล"
            className="w-full rounded-xl border p-3 text-sm"
          />

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="รหัสผ่าน"
            className="w-full rounded-xl border p-3 text-sm"
          />

          <div className="text-right">
            <button
              type="button"
              onClick={() => setShowForgotPassword(true)}
              className="text-xs underline text-[#6D4C92]"
            >
              ลืมรหัสผ่าน?
            </button>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full rounded-xl py-3 font-semibold text-white"
            style={{ backgroundColor: colors.amethyst }}
          >
            {isLoading ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ"}
          </button>
        </form>

        {/* -------- SOCIAL LOGIN -------- */}
        {window.location.hostname !== testDomain && (
          <>
            <div className="mt-6 text-center text-sm text-gray-500">
              หรือดำเนินการต่อด้วย
            </div>

            <div className="mt-4 grid grid-cols-2 gap-3">
              {/* Apple */}
              <button
                onClick={handleAppleLogin}
                className="flex items-center justify-center gap-2 py-2.5 rounded-xl text-white"
                style={{ backgroundColor: "#000" }}
              >
                 Apple
              </button>

              {/* Google */}
              <div className="relative">
                <button
                  className="w-full flex items-center justify-center gap-2 py-2.5 rounded-xl text-white"
                  style={{ backgroundColor: colors.darkAmethyst }}
                >
                  Google
                </button>

                <div className="absolute inset-0 opacity-0">
                  <GoogleLogin
                    onSuccess={async (res) => {
                      const idToken = res.credential;
                      if (!idToken) {
                        toast.error("ไม่พบโทเค็น Google");
                        return;
                      }
                      await googleLogin(idToken);
                      navigate("/");
                    }}
                    onError={() => toast.error("เข้าสู่ระบบด้วย Google ไม่สำเร็จ")}
                  />
                </div>
              </div>
            </div>

            <p className="mt-6 text-center text-sm">
              New here?{" "}
              <Link to="/register" className="underline text-[#6D4C92]">
                สร้างบัญชี
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
